// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__e093m","dialog":"modal_dialog__S-8HB"};